import { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { auth } from '@festpix/services';
import { getUserWallet, Wallet } from '@festpix/services';
import { colors, spacing, borderRadius, typography, shadows } from '@festpix/ui';
import AttendeeLayout from '../../components/AttendeeLayout';

export default function QRScreen() {
  const [wallet, setWallet] = useState<Wallet | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadWallet();
  }, []);

  const loadWallet = async () => {
    try {
      const user = auth.currentUser;
      if (user) {
        const userWallet = await getUserWallet(user.uid);
        setWallet(userWallet);
      }
    } catch (err) {
      console.error('Error loading wallet:', err);
      setError('Erro ao carregar carteira');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <AttendeeLayout showBackButton>
        <div style={styles.loadingContainer}>
          <div style={styles.spinner} />
          <p style={styles.loadingText}>Carregando...</p>
        </div>
      </AttendeeLayout>
    );
  }

  if (!wallet || error) {
    return (
      <AttendeeLayout showBackButton>
        <div style={styles.container}>
          <p style={styles.errorText}>{error || 'Carteira nao encontrada'}</p>
        </div>
      </AttendeeLayout>
    );
  }

  return (
    <AttendeeLayout showBackButton>
      <div style={styles.container}>
        <h1 style={styles.title}>Escaneie este QR Code para pagar</h1>

        <div style={styles.qrContainer}>
          <QRCodeSVG value={wallet.qrCode} size={250} />
        </div>

        <p style={styles.balanceText}>
          Saldo: R$ {wallet.balance.toFixed(2).replace('.', ',')}
        </p>

        <p style={styles.instructionText}>
          Mostre este codigo para o vendedor escanear e realizar a cobranca.
        </p>
      </div>
    </AttendeeLayout>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: spacing.lg,
    backgroundColor: colors.background,
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: colors.background,
  },
  spinner: {
    width: 40,
    height: 40,
    border: `3px solid ${colors.border}`,
    borderTop: `3px solid ${colors.primary}`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadingText: {
    marginTop: spacing.md,
    color: colors.textSecondary,
  },
  backButtonTop: {
    position: 'absolute',
    top: spacing.lg,
    left: spacing.lg,
    background: 'none',
    border: 'none',
    color: colors.primary,
    fontSize: typography.fontSize.md,
    cursor: 'pointer',
    padding: spacing.sm,
  },
  title: {
    fontSize: typography.fontSize.lg,
    fontWeight: typography.fontWeight.bold,
    marginBottom: spacing.xl,
    color: colors.text,
    textAlign: 'center',
  },
  qrContainer: {
    padding: spacing.lg,
    backgroundColor: colors.cardBackground,
    borderRadius: borderRadius.lg,
    boxShadow: shadows.md,
  },
  balanceText: {
    marginTop: spacing.xl,
    fontSize: typography.fontSize.lg,
    color: colors.textSecondary,
  },
  instructionText: {
    marginTop: spacing.md,
    fontSize: typography.fontSize.sm,
    color: colors.textDescription,
    textAlign: 'center',
    maxWidth: 280,
  },
  errorText: {
    fontSize: typography.fontSize.md,
    color: colors.textSecondary,
    marginBottom: spacing.lg,
  },
  backButton: {
    backgroundColor: colors.primary,
    padding: `${spacing.md}px ${spacing.lg}px`,
    borderRadius: borderRadius.md,
    color: colors.textLight,
    fontSize: typography.fontSize.md,
    fontWeight: typography.fontWeight.semibold,
    border: 'none',
    cursor: 'pointer',
  },
};
